import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class CodeGlNo extends TrackableEntity {
    id: number = 0;
    glNo: string = '';
    glNo0: string = '';
    glNo1: string = '';
    glNo2: string = '';
    glNo3: string = '';
    glNo4: string = '';
    glNo5: string = '';
    glTypeText: string = '';
    glType: string = '';
    glGroupText: string = '';
    glGroup: string = '';
    glSubGroupText: string = '';
    glSubGroup: string = '';
    glSubGroup3Text: string = '';
    glDescription: string = '';
    frontGlDesc: string = '';
    localDesc: string = '';
    frontLocalDesc: string = '';
    inactive: boolean = false;
    cashFlowType: string = '';
    cashFlowGroup: string = '';
    remark: string = '';
    inactiveDate: string | null = null;
    inactiveBy: string = '';

    otherGlDesc: string = '';
    otherFrontGlDesc: string = '';
    otherLocalDesc: string = '';
    otherFrontLocalDesc: string = '';
    otherRemark: string = '';
    otherId: number = 0;

    useOnBillPay: boolean = false;
    useOnCustPay: boolean = false;
    billPayShowOption: string = '';
    custPayShowOption: string = '';

    // for only font-end
    edit: boolean = false;
    view: boolean = false;
    isDefault : boolean = false;
    displayDesc: string = '';
    displayLocalDesc: string = '';
    otherdisplayDesc: string = '';
    otherdisplayLocalDesc: string = '';
    existingCode : string = '';
    otherExistingCode : string = '';
    otehrGlno: string = '';

    constructor(init?:Partial<CodeGlNo>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'glTypeText', 'glGroupText', 'glSubGroupText', 'glSubGroup3Text', 'existingCode', 'otherExistingCode','isDefault');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return CodeGlNo.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_CODEGLNO' }),
        'glNo': new DBMappingInfo({ field: 'F_GlNo', table: 'T_CODEGLNO' }),
        'glType': new DBMappingInfo({ field: 'F_GlType', table: 'T_CODEGLNO' }),
        'glGroup': new DBMappingInfo({ field: 'F_GlGroup', table: 'T_CODEGLNO' }),
        'glSubGroup': new DBMappingInfo({ field: 'F_GlSubGroup', table: 'T_CODEGLNO' }),
        'glDescription': new DBMappingInfo({ field: 'F_GlDescription', table: 'T_CODEGLNO' }),
        'localDesc': new DBMappingInfo({ field: 'F_LocalDesc', table: 'T_CODEGLNO' }),
        'inactive': new DBMappingInfo({ field: 'F_Inactive', table: 'T_CODEGLNO' }),
        'inactiveDate': new DBMappingInfo({ field: 'F_InactiveDate', table: 'T_CODEGLNO' }),
        'remark': new DBMappingInfo({ field: 'F_Remark', table: 'T_CODEGLNO' }),
        'inactiveBy': new DBMappingInfo({ field: 'InactiveBy', table: 'T_CODEGLNO' }),
        'useOnBillPay': new DBMappingInfo({ field: 'F_UseOnBillPay', table: 'T_CODEGLNO' }),
        'useOnCustPay': new DBMappingInfo({ field: 'F_UseOnCustPay', table: 'T_CODEGLNO' }),
        'billPayShowOption': new DBMappingInfo({ field: 'F_BillPayShowOption', table: 'T_CODEGLNO' }),
        'custPayShowOption': new DBMappingInfo({ field: 'F_CustPayShowOption', table: 'T_CODEGLNO' }),
    };
}
